// components/layout.js
// https://nextjs.org/docs/basic-features/layouts

// import Navbar from './navbar'
// import Footer from './footer'
import { atom, useAtom } from 'jotai'
import _ from "lodash"
import { useState, useEffect, forwardRef } from 'react'

import { FullPage, Slide } from 'react-full-page';
// import FadeIn from 'react-fade-in';

// useref needs forwarding
// https://stackoverflow.com/questions/61192450/useref-hook-on-a-custom-component

/*
omg scrolling on ios is a massive pain- need custom inobounce library
https://stackoverflow.com/questions/39053177/how-to-set-webkit-overflow-scrolling-inline-style-on-react-component

*/

const SlideFull = forwardRef((props, ref) => {
  //const SlideFull = forwardRef((props, ref) => {
// const SlideFull = ({ children, ...restProps }) => {
//export default function SlideFull({ children, ...restProps }) {
  const cn = `flex flex-col w-full min-h-displayHt items-center justify-center text-center relative ${props.className}`;
  const styles = {
    //...constants.mainViewportHeightStyle,
    //'zIndex': 0,
    overflowScrolling: "touch", 
    WebkitOverflowScrolling: "touch"
  }
  return (
    //   <div className="flex w-full h-displayHt flex-col items-center justify-center bg-slate-300">{children}</div>
    // <Slide id={props.id} key={props.index} style={{background:"#ff0000", display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
    //   {/* {props.children} */}
    //   HelloABC
    // </Slide>
    <div id={props.id} ref={ref} className="overflow-y-auto overflow-x-hidden w-full h-screen relative" style={styles}>
    <section className={cn} >
      {/* <FadeIn> */}
       {props.children}
       {/* </FadeIn> */}
    </section>
    </div>
  )
})



// export default React.forwardRef(SlideFull)
export default SlideFull


//const ButtonTextIcon = forwardRef((props,ref) => {